import { api } from "./configs/axiosConfigs"

export const StockProductsAPI = {

    getProductAvailability: async (data: any) => {
        const response = await api.get(
            '/stockProduct/availability', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    get: async (data?: object) => {
        const response = await api.get(
            '/stockProduct', { params: data }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    create: async (data: object) => {
        const response = await api.post(
            '/stockProduct/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    adjustment: async (data: object) => {
        const response = await api.post(
            '/stockProduct/adjustment', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

}